// extracted by mini-css-extract-plugin
module.exports = {"circle":"styles_circle__egpJg","badge":"styles_badge__50Qia"};